<template>
    <vx-box color="white" class="col-span-1 h-full">
        <h2
            class="px-6 pt-6 pb-3 mb-0 font-extrabold text-slate-8000 text-base"
        >
            Getting Started
        </h2>
        <vx-list>
            <vx-list-item href="/settings/relay">
                <vx-list-icon class="bg-emerald-100">
                    <font-awesome-icon widthAuto :icon="faRobot" />
                </vx-list-icon>
                See our Integrations
            </vx-list-item>
            <vx-list-item href="/settings/integrations#/contact-collector">
                <vx-list-icon class="bg-amber-100">
                    <font-awesome-icon widthAuto :icon="faMessageCaptions" />
                </vx-list-icon>
                Install Contact Collector
            </vx-list-item>
            <vx-list-item
                href="https://docs.voxie.com/reference/capture-a-conversion"
                target="_blank"
                rel="noopener noreferrer"
            >
                <vx-list-icon class="bg-rose-200">
                    <font-awesome-icon widthAuto :icon="faStar" />
                </vx-list-icon>
                Start Capturing Conversions
            </vx-list-item>
        </vx-list>
        <div class="px-6 pb-6 pt-4">
            <vx-button
                href="https://docs.voxie.com"
                target="_blank"
                rel="noopener noreferrer"
                size="sm"
                outline
                color="muted-light"
            >
                API Docs
                <font-awesome-icon widthAuto
                    :icon="faArrowRight"
                    size="sm"
                ></font-awesome-icon>
            </vx-button>
        </div>
    </vx-box>
</template>

<script setup>
import {
    VxBox,
    VxButton,
    VxList,
    VxListIcon,
    VxListItem,
} from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faArrowRight,
    faStar,
    faRobot,
    faMessageCaptions,
} from "@fortawesome/pro-solid-svg-icons";
</script>
